import { I18N } from 'aurelia-i18n';
import { StringHelper } from '../../../../helpers/string-helper';
import { AccountPaymentItem } from '../../../../models/account-payment-item';
import { IValidationRule } from '../i-validation-rule';
import { RuleValidationResult } from '../rule-validation-result';

export class MeetsPortalMaxAmountRule implements IValidationRule {
	constructor(private i18n: I18N, private items: AccountPaymentItem[], private portalMaximumPaymentAmount: number) { }

	validate(): RuleValidationResult {
		let result: RuleValidationResult = new RuleValidationResult();

		if (!this.items || !this.portalMaximumPaymentAmount) {
			return result;
		}

		let totalAmount: number = 0;

		this.items.forEach((i: AccountPaymentItem) => {
			if (i.isSelected) {
				let parsedAmount: number = parseFloat(i.enteredAmount);
				if (!isNaN(parsedAmount)) {
					totalAmount += parsedAmount;
				}
			}
		});

		result.isValid = (totalAmount <= this.portalMaximumPaymentAmount);

		if (!result.isValid) {
			result.errorMessage = this.i18n.i18next.t('totalPaymentDoesNotMeetMaxLimits', {
				defaultValue: 'Total payment cannot exceed ' + StringHelper.formatCurrency(this.portalMaximumPaymentAmount) + '.',
				maxPayment: StringHelper.formatCurrency(this.portalMaximumPaymentAmount),
			});
		}

		return result;
	}
}
